import React from "react";

export default function apiGateway({ color = "white" }) {
  const str1 = "a1.794 1.794 0 1 0 0";
  const str2 = "3.588 1.794 1.794 0 0 0 0-3.588m";
  const str3 = "a1.795 1.795 0 1 0 0 3.59 1.795 1.795 0 0 0";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20">
      <path
        fill={color}
        fillRule="evenodd"
        d={`M7.179 0${str1} 3.589A1.794 1.794 0 0 0 7.18 0m0 5.384${str1} ${str2}5.384 0${str1} ${str2}0 5.384${str1} ${str2}-5.384 0${str1} ${str2}5.384-7.178${str1}-3.59 1.794 1.794 0 0 0 0 3.59M1.795 10.768${str3} 0-3.59m0-5.384${str3} 0-3.59m0-5.384${str3} 0-3.59m5.384 16.152${str1} 3.59 1.794 1.794 0 1 0 0-3.59`}
      />
    </svg>
  );
}
